export default __webpack_public_path__ + "static/media/secondOpinionHome.a575d453.png";